import type { DocumentAssemblerTemplateVersionStatus } from '@commenda/api';
import { Badge } from '@commenda/kakashi';

import { DocumentAssemblerHelper } from './DocumentAssemblerHelper';

interface DocumentAssemblerVersionStatusBadgeProps {
  status: DocumentAssemblerTemplateVersionStatus;
}

export const DocumentAssemblerVersionStatusBadge = ({
  status,
}: DocumentAssemblerVersionStatusBadgeProps) => {
  const badge = DocumentAssemblerHelper.getVersionStatusBadge(status);

  return <Badge variant={badge.variant}>{badge.label}</Badge>;
};
